import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import {
  FileComponent,
  SalesDropzone,
  NewDropzone, FileDropzone
} from '../../../common/Dropzone/Dropzone';
import { ActionButton, AltButton } from '../../../common/Buttons/Buttons';
import { MembershipImage } from './LandingComponents';
import { filterById } from '../../../../assets/helpers/funciones';
import {
  paymentMethods, banksOptions, bankTransferList,
  pagoMovilList, salesAgentPhoneNumber, cashBakOptions, idCodes

} from '../../../../assets/helpers/options';
import zelleLogo from '../../../../images/zelle.png';
import bancamiga from '../../../../images/Bancamiga.png';
import mercantil from '../../../../images/mercantil.png';
import banesco from '../../../../images/banesco.png';
import paypal from '../../../../images/paymentMethodPaypal.svg';
import pagoMovil from '../../../../images/paymentMethodPagoMovil.svg';
import binancePayMethod from '../../../../images/binancePayMethod.svg';
import { Input } from '../../../common/Forms/Input/Input';
import { PaymentElement } from '@stripe/react-stripe-js';
import { useStripe, useElements } from '@stripe/react-stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import safePayment from '../../../../images/safePayment.svg';

import './LandingModals.scss';
import { notify } from '../../../../assets/helpers/toast';

const createAdjustmentFile = {
  name: "Adjuntar Comprobante *",
  instructions: "Adjuntar Comprobante *",
  label: "(JPG, PNG, PDF, máx. 3MB)",
  message: "Arrastrar o buscar Documento",
  uploaded: "",
};


export const AccountsSelect = (props) => {
  const { methods, register, errors } = props;

  let options = [];
  options = methods;

  for (let i = 0; i < methods?.length; i++) {
    if (
      ![
        paymentMethods.CASH_BS,
        paymentMethods.CASH_USD,
        paymentMethods.TRANSFERENCIA_BANESCO,
        paymentMethods.TRANSFERENCIA_MERCANTIL,
      ].includes(methods[i]?.name)
    ) {
      return null;
    }
  }
  return (
    <Input
      bootstrap={'col-12 col-md-6'}
      label={'Opciones de pago'}
      type={'select'}
      name={'paymentOption'}
      register={register}
      placeholder={''}
      options={options}
      errors={errors?.paymentOption?.message}
      disabled={false}
    />
  );
};

export const RefComponent = (props) => {
  const { methods, paymentModal, payment, handleReferenceChange } = props;

  for (let i = 0; i < methods?.length; i++) {
    if (
      [paymentMethods.CASH_BS, paymentMethods.CASH_USD].includes(
        methods[i]?.name
      )
    ) {
      return null;
    }
  }
  return (
    <>
      <div className={`input-component-container col-12 col-md-6`}>
        <label style={{ textAlign: 'center' }}>{`Referencia de Pago ${paymentModal?.paymentNumber > 1 ? paymentModal?.paymentNumber : ''
          }`}</label>
        <div>
          <div className="input-sublabel-container">
            <input
              name={`reference`}
              value={payment?.reference}
              onChange={handleReferenceChange}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export const PaymentMethodDetails = (props) => {
  const { method, methods } = props;
  const filteredMethod = methods?.filter(
    (m) =>
      m?._id === method?._id &&
      ![
        paymentMethods.CASH_BS,
        paymentMethods.CASH_USD,
        paymentMethods.TRANSFERENCIA_BANESCO,
        paymentMethods.TRANSFERENCIA_MERCANTIL,
      ]?.includes(m?.name)
  );

  if (filteredMethod?.length > 0) {
    return (
      <p style={{ margin: '24px 12px 24px 12px' }}>
        {method?.details?.account && (
          <>
            Cuenta: <b>{method?.details?.account}</b> <br />
          </>
        )}
        {method?.details?.accountNumber && (
          <>
            Numero de Cuenta:: <b>{method?.details?.accountNumber}</b> <br />
          </>
        )}
        {method?.details?.bank && (
          <>
            Banco: <b>{method?.details?.bank}</b> <br />
          </>
        )}
        {method?.details?.phone && (
          <>
            Telefono: <b>{method?.details?.phone}</b> <br />
          </>
        )}
        {method?.details?.rif && (
          <>
            RIF: <b>{method?.details?.rif}</b> <br />
          </>
        )}
      </p>
    );
  } else return null;
};

export const AmounComponent = (props) => {
  const { amount, amountBsS } = props;

  if (!amountBsS) {
    return null;
  }
  return (
    <div className="ammount-container">
      <h5>Monto</h5>
      <h6>{amount?.toFixed(2) + " $    " + amountBsS?.toFixed(2) + " Bs"}</h6>
    </div>
  );
};

export const MethodLogoContainer = (props) => {

  const { methods } = props;
  if (methods?.length > 0) {
    return (
      <div className="payment-method-logos-container">
        {methods?.map((m, i) => (
          <MethodLogo key={m?.name + i} name={m?.name} />
        ))}
      </div>
    );
  } else return null;
};

export const MethodLogo = (props) => {
  const { name } = props;

  let src = '';
  switch (name) {
    case paymentMethods.ZELLE:
      src = zelleLogo;
      break;
    case paymentMethods.TRANSFERENCIA_MERCANTIL:
      src = mercantil;
      break;
    case paymentMethods.TRANSFERENCIA_BANESCO:
      src = banesco;
      break;
    case paymentMethods.PAYPAL:
      src = paypal;
      break;
    case paymentMethods.PAGO_MÓVIL:
      src = pagoMovil;
      break;
    case paymentMethods.PAGO_MÓVIL_BANCAMIGA:
      src = pagoMovil;
      break;
    case paymentMethods.BINANCE:
      src = binancePayMethod;
      break;

    default:
  }
  if (src) {
    return <img src={src} alt="src" />;
  } else return null;
};

export const IGTF = (props) => {
  const { methods } = props;

  let isDollar = false;

  for (let i = 0; i < methods.length; i++) {
    if (methods[i].currency === 'USD') {
      isDollar = true;
    }
  }

  if (!isDollar) {
    return null;
  }

  return (
    <p className="igtf-message-container">
      Este monto incluye el <b>IGTF (3%)</b> por utilizar un método de pago de
      une monede distinta a la de curso legal en Venezuela. Para más
      información, consulte la <b>Gaceta Oficial N°6.687</b>
    </p>
  );
};

export const PaymentModal = (props) => {
  const {
    getRootProps,
    getInputProps,
    paymentModal,
    selectPaymentMethod,
    paymentImage,
    removeImage,
    acceptPayment,
    watch,
    dollarRate,
    register,
    errors,
  } = props;
  return (
    <Modal
      size="lg"
      centered
      show={paymentModal?.isOpen}
      onHide={() => selectPaymentMethod('', paymentModal?.paymentNumber)}
    >
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <MembershipImage
          membership={{ code: paymentModal?.selectedMembership?.code }}
        />
        <div className="landing-payment-modal-header">
          <AmounComponent
            selectedMembership={paymentModal?.selectedMembership}
            paymentModal={paymentModal}
            dollarRate={dollarRate}
            amount={parseFloat(watch(`amount${paymentModal?.paymentNumber}`))}
            amountBsS={parseFloat(
              watch(`amountBsS${paymentModal?.paymentNumber}`)
            )}
          />

          <MethodLogoContainer methods={paymentModal?.methods} />
        </div>
        <div className="landing-payment-modal-body">
          <IGTF methods={paymentModal?.methods} />
          <h6 className="landing-payment-modal-title">Datos de Pago</h6>
          {paymentModal?.methods?.map((p) => (
            <PaymentMethodDetails
              key={p?.details?.account}
              method={p}
              paymentOption={watch('paymentOption')}
              methods={paymentModal?.methods}
            />
          ))}
          <div
            style={{ width: '100%' }}
            className="row landing-payment-modals-form"
          >
            <AccountsSelect
              register={register}
              errors={errors}
              methods={paymentModal?.methods}
            />
            <RefComponent
              paymentModal={paymentModal}
              register={register}
              errors={errors}
              methods={paymentModal?.methods}
            />
          </div>
          {paymentModal?.methods[0]?.name !== paymentMethods.PUNTO_DE_VENTA && (
            <div className="buttons-center-container">
              {paymentImage ? (
                <FileComponent
                  file={paymentImage}
                  remove={() => removeImage(paymentModal?.paymentNumber)}
                />
              ) : (
                <SalesDropzone
                  instructions={'Adjuntar Comprobante *'}
                  maxWeight={'(JPG, PNG, PDF, máx. 3MB)'}
                  getRootProps={getRootProps}
                  getInputProps={getInputProps}
                  message="Arrastrar o buscar Documento"
                />
              )}
            </div>
          )}
        </div>
      </Modal.Body>
      <div className="buttons-center-container">
        <AltButton
          label={`Cancelar `}
          action={() => selectPaymentMethod('', paymentModal?.paymentNumber)}
        />
        <ActionButton label={`Pagar `} action={() => acceptPayment()} />
      </div>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};


export const NewPaymentModal = (props) => {
  const {
    cancelPayment,
    fileUploaded,
    setFileUploaded,
    acceptPayment,
    watch,
    register,
    errors,
    payment,
    handleReferenceChange,
    control,
    setValue
  } = props;


  const genericMethods = payment?.methods?.filter(
    (m) =>
      [
        ...bankTransferList, ...pagoMovilList
      ]?.includes(m?.name)
  );

  const handleCardDateChange = (value, index) => {
    let formattedValue = value.replace(/\D/g, '');
    if (formattedValue.length > 2) {
      formattedValue =
        formattedValue.substring(0, 2) + '/' + formattedValue.substring(2, 4);
    }

    if (formattedValue.length > 5) {
      formattedValue = formattedValue.substring(0, 5);
    }

    if (formattedValue.length >= 2) {
      const monthPart = formattedValue.substring(0, 2);
      const month = parseInt(monthPart, 10);
      if (month > 12) {
        formattedValue = '12' + formattedValue.substring(2);
      }
      if (month === 0) {
        // Evitar 00 para mes
        formattedValue = '01' + formattedValue.substring(2);
      }
    }
    setValue(`cardDate${index}`, formattedValue);
  };

  return (
    <Modal
      size="lg"
      centered
      show={payment?.isOpen}
      onHide={() => cancelPayment(payment?.paymentNumber)}
    >
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <MembershipImage membership={payment?.selectedMembership} />
        <div className="landing-payment-modal-header">
          <AmounComponent
            amount={payment?.amount}
            amountBsS={payment?.amountBsS}
          />

          <MethodLogoContainer methods={payment?.methods} />
        </div>
        <div className="landing-payment-modal-body">
          <h6 className="landing-payment-modal-title">Datos de Pago</h6>
          {payment?.methods?.map((p) => (
            <PaymentMethodDetails
              key={p?.details?.account}
              method={p}
              paymentOption={watch('paymentOption')}
              methods={payment?.methods}
            />
          ))}

          {
            [paymentMethods?.PAGO_MÓVIL_BANCAMIGA]?.includes(
              payment?.methods[0]?.name
            ) && (
              <div style={{ width: '100%' }}
                className="row">
                <Input
                  bootstrap={'col-12 col-md-6'}
                  label={'Nro. Teléfono asociado a pago móvil'}
                  type={'number'}
                  name={`phone${payment?.paymentNumber}`}
                  placeholder={"4143579865"}
                  register={register}
                  errors={errors?.[`phone${payment?.paymentNumber}`]?.message}
                  disabled={false}
                />
                <Input
                  bootstrap={'col-12 col-md-6'}
                  label={'Fecha de Pago'}
                  type={'date'}
                  name={`date${payment?.paymentNumber}`}
                  register={register}
                  errors={errors?.[`date${payment?.paymentNumber}`]?.message}
                  control={control}
                  disabled={false}
                />
                <Input
                  bootstrap={'col-12 col-md-6'}
                  label={'¿Qué banco utilizaste?'}
                  type={'select'}
                  name={`bank${payment?.paymentNumber}`}
                  register={register}
                  placeholder={''}
                  options={banksOptions}
                  errors={errors?.[`bank${payment?.paymentNumber}`]?.message}
                  disabled={false}
                />
              </div>
            )
          }

          {![
            paymentMethods?.NATIONAL_TDC,
          ].includes(
            filterById(payment?.methods, watch('paymentOption'))?.name
          ) && (
              <>

                <div
                  style={{ width: '100%' }}
                  className="row landing-payment-modals-form"
                >

                  <AccountsSelect
                    register={register}
                    errors={errors}
                    methods={payment?.methods}
                  />
                  <AmountCashReceived
                    register={register}
                    errors={errors}
                    watch={watch}
                    methods={payment?.methods}
                    payment={payment}
                  />
                  <RefComponent
                    paymentModal={payment}
                    register={register}
                    errors={errors}
                    methods={payment?.methods}
                    payment={payment}
                    handleReferenceChange={handleReferenceChange}
                  />
                </div>
              </>
            )}
          {![paymentMethods?.PUNTO_DE_VENTA, paymentMethods?.TDC, paymentMethods?.NATIONAL_TDC]?.includes(
            payment?.methods[0]?.name
          ) && (
              <div className="buttons-center-container">
                <NewDropzone
                  fileUploaded={fileUploaded}
                  setFileUploaded={setFileUploaded}
                  img={createAdjustmentFile}
                  index={payment?.paymentNumber}
                />
              </div>
            )}
          {genericMethods?.length > 0 &&
            <p style={{ textAlign: "center" }}>De existir un problema por favor ponte en contacto con nuestros asesores de venta <b>{salesAgentPhoneNumber}</b> </p>
          }
          {[paymentMethods?.NATIONAL_TDC].includes(
            filterById(payment?.methods, watch('paymentOption'))?.name
          ) && (
              <>


                {new Date() >= new Date('2026-01-26T00:00:00Z') ?
                  <div style={{ width: "100%", display: "flex", flexFlow: "column", alignItems: "center" }}><img style={{ width: "200px", borderRadius: "8px" }} src={bancamiga} alt="" />
                    <div
                      style={{
                        backgroundColor: '#d4edda',
                        color: '#155724',
                        border: '1px solid #c3e6cb',
                        borderRadius: '4px',
                        padding: '12px',
                        margin: '16px 0',
                        textAlign: 'center',
                        fontWeight: 500,
                      }}
                    >
                      {"15% de descuento sobre la facturación si pagas con tus productos Bancamiga"}

                    </div> </div> : ""
                }
                <div style={{ width: '100%' }} className="row">
                  <Input
                    bootstrap={'col-12 col-md-12'}
                    label={'Número de tarjeta '}
                    type={'text'}
                    name={`card${payment?.paymentNumber}`}
                    placeholder={'1234 1234 1234 1234'}
                    register={register}
                    errors={errors?.[`card${payment?.paymentNumber}`]?.message}
                    disabled={false}
                  />
                </div>
                <div style={{ width: '100%' }} className="row">
                  <Input
                    bootstrap={'col-12 col-md-6'}
                    label={'Fecha de vencimiento '}
                    type={'card-date'}
                    name={`cardDate${payment?.paymentNumber}`}
                    onChange={(e) =>
                      handleCardDateChange(e.target.value, payment?.paymentNumber)
                    }
                    placeholder={'MM/AA'}
                    register={register}
                    errors={errors?.[`card${payment?.paymentNumber}`]?.message}
                    disabled={false}
                  />
                  <Input
                    bootstrap={'col-12 col-md-6'}
                    label={'Código de seguridad '}
                    type={'text'}
                    name={`cvc${payment?.paymentNumber}`}
                    placeholder={'CVC'}
                    register={register}
                    errors={errors?.[`cvc${payment?.paymentNumber}`]?.message}
                    disabled={false}
                  />
                </div>
                <div style={{ width: '100%' }} className="row">
                  <Input
                    bootstrap={'col-12 col-md-4'}
                    label={'Tipo de documento'}
                    type={'select'}
                    name={`identificationType${payment?.paymentNumber}`}
                    options={idCodes}
                    register={register}
                    capitalizeOff={true}
                    errors={
                      errors?.[`identificationType${payment?.paymentNumber}`]
                        ?.message
                    }
                    disabled={false}
                  />
                  <Input
                    bootstrap={'col-12 col-md-8'}
                    label={'Cédula'}
                    type={'text'}
                    name={`identification${payment?.paymentNumber}`}
                    register={register}
                    errors={
                      errors?.[`identification${payment?.paymentNumber}`]?.message
                    }
                    disabled={false}
                  />
                </div>
                {new Date() >= new Date('2026-01-26T00:00:00Z') ?
                  <div
                    style={{
                      borderRadius: '4px',
                      marginTop: '12px',
                      textAlign: 'center',
                      fontWeight: 500,
                    }}
                  >
                    {"No se permite la aplicación de doble descuento sobre una misma afiliación."}

                  </div> : ""
                }

                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    marginTop: '16px',
                    justifyContent: 'center',
                  }}
                  className="row"
                >
                  <img
                    style={{ width: '70%' }}
                    className="safePayment"
                    src={safePayment}
                    alt="safePayment"
                  />
                </div>
              </>
            )}
        </div>
      </Modal.Body>
      <div className="buttons-center-container">
        <AltButton
          label={`Cancelar `}
          action={() => cancelPayment(payment?.paymentNumber)}
        />
        <ActionButton label={`Pagar `} action={() => acceptPayment()} />
      </div>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const StripeModal = (props) => {
  const {
    stripeModal,
    handleStipeModal,
    clientSecret,
    successfulStripe,
  } = props;

  const publishableKey = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

  return (
    <Modal
      size="lg"
      centered
      show={stripeModal?.isOpen}
      onHide={() => handleStipeModal(0, stripeModal?.paymentNumber)}
    >
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <MembershipImage
          membership={{ code: stripeModal?.selectedMembership?.code }}
        />
        <div className="landing-payment-modal-header">
          <AmounComponent
            selectedMembership={stripeModal?.selectedMembership}
            paymentModal={stripeModal}
            amount={stripeModal?.amount}
            amountBsS={stripeModal?.amountBsS}
          />

          {/* <MethodLogoContainer methods={paymentModal?.methods} /> */}
        </div>
        <div className="landing-payment-modal-body">
          <h6 className="landing-payment-modal-title">Datos de Pago</h6>

          {clientSecret && publishableKey && (
            <Elements stripe={publishableKey} options={{ clientSecret }}>
              <CheckoutForm
                stripeModal={stripeModal}
                handleStipeModal={handleStipeModal}
                successfulStripe={successfulStripe}
              />
            </Elements>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const CheckoutForm = (props) => {
  const { stripeModal, handleStipeModal, successfulStripe } = props;
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsProcessing(true);

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // Make sure to change this to your payment completion page
        return_url: `${window.location.origin}/completion`,
      },
      redirect: 'if_required',
    });

    if (error?.type === 'card_error' || error?.type === 'validation_error') {
      setMessage(error.message);
    }
    if (paymentIntent?.status === 'succeeded') {
      notify('Su pago ha sido registrado con éxito', 'success');
      successfulStripe(stripeModal.paymentNumber);
    } else {
      setMessage('An unexpected error occured.');
    }

    setIsProcessing(false);
  };

  return (
    <form id="payment-form">
      <PaymentElement id="payment-element" />
      {message && <div id="payment-message">{message}</div>}

      {!isProcessing && (
        <div
          style={{ margin: '24px 0px' }}
          className="buttons-center-container"
        >
          <AltButton
            label={`Cancelar `}
            action={() => handleStipeModal(0, stripeModal.paymentNumber)}
          />

          {isProcessing || !stripe || !elements ? null : (
            <ActionButton label={`Pagar `} action={handleSubmit} />
          )}
        </div>
      )}
    </form>
  );
};


export const AmountCashReceived = (props) => {
  const { payment, methods, register, errors } = props;

  for (let i = 0; i < methods?.length; i++) {
    if (
      ![
        paymentMethods.CASH_USD,
        paymentMethods.CASH_BS,
        paymentMethods.CASH_EUR,
      ].includes(methods[i]?.name)
    ) {
      return null;
    }
  }

  return (
    <Input
      bootstrap={"col-12 col-md-6"}
      label={"Monto Recibido $"}
      type={"number"}
      name={`paid${payment.paymentNumber}`}
      register={register}
      placeholder={""}
      errors={errors?.[`paid${payment.paymentNumber}`]?.message}
      disabled={false}
    />
  );
};



export const CashBackComponent = (props) => {
  const {
    register,
    errors,
    watch,
    options,
    onChange,
    handleDrop,
    cashBackImage,
    removeFile,
    errorsDropzone,
  } = props;
  const filterMethods = options?.paymemtMethodOptions?.filter(
    (m) => ![paymentMethods?.CASHEA, paymentMethods?.RESERVE]?.includes(m?.name)
  );

  if (watch("paid") && watch("paidBsS")) {
    return (
      <>
        <div className="col-12">
          <h5 style={{ margin: "12px 0px" }}>Vuelto</h5>
        </div>
        <div className="row">
          <Input
            bootstrap={"col-12 col-md-2"}
            label={"Monto total Recibido USD $ *"}
            type={"number"}
            name={"paid"}
            register={register}
            placeholder={""}
            errors={errors?.paid?.message}
            disabled={true}
          />
          <Input
            bootstrap={"col-12 col-md-2"}
            label={"Monto total Recibido BsS*"}
            type={"number"}
            name={"paidBsS"}
            register={register}
            placeholder={""}
            errors={errors?.paidBsS?.message}
            disabled={true}
          />
          <Input
            bootstrap={"col-12 col-md-2"}
            label={"Vuelto a entregar USD $ *"}
            type={"number"}
            name={"amountReturned"}
            register={register}
            options={options?.paymemtMethodOptions}
            placeholder={""}
            errors={errors?.amountReturned?.message}
            disabled={true}
          />
          <Input
            bootstrap={"col-12 col-md-2"}
            label={"Vuelto a entregar BsS $ *"}
            type={"number"}
            name={"amountReturnedBsS"}
            register={register}
            options={options?.paymemtMethodOptions}
            placeholder={""}
            errors={errors?.amountReturnedBsS?.message}
            disabled={true}
          />
          <div className="col-md-4"></div>
          <Input
            bootstrap={"col-12 col-md-3"}
            label={"Cantidad de métodos de vuelto *"}
            type={"select"}
            name={"cashbackMethodsQuantity"}
            register={register}
            options={cashBakOptions}
            placeholder={""}
            errors={errors?.cashbackMethodsQuantity?.message}
            onChange={() => onChange?.handleCashbackMethodsQuantity()}
          // disabled={true}
          />
          <div className="col-md-9"></div>

          <table className="table payments-table">
            <thead>
              <tr>
                <th scope="col">Método de vuelto</th>
                <th scope="col">Monto USD Vuelto</th>
                <th scope="col">Monto Bs Vuelto</th>
                <th scope="col">Referencia Vuelto</th>
                <th scope="col">Adjuntar Comprobante</th>
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: parseFloat(watch("cashbackMethodsQuantity")) }).map((_, i) => (
                <tr key={i}>
                  <td>
                    <Input
                      bootstrap={"col-12"}
                      // label={`Método de vuelto ${i + 1}*`}
                      type={"select"}
                      name={`returnedMethod${i}`}
                      register={register}
                      options={filterMethods}
                      placeholder={""}
                      errors={errors[`returnedMethod${i}`]?.message}
                    />
                  </td>
                  <td>
                    <Input
                      bootstrap={"col-12"}
                      // label={`Monto USD Vuelto ${i + 1} *`}
                      type={"number"}
                      name={`returnedAmount${i}`}
                      register={register}
                      placeholder={""}
                      errors={errors[`returnedAmount${i}`]?.message}
                      onChange={() => onChange?.handleCashbackBs(i)}
                      disabled={parseFloat(watch("cashbackMethodsQuantity")) - 1 === i}
                    />
                  </td>
                  <td>
                    <Input
                      bootstrap={"col-12"}
                      // label={`Monto Bs Vuelto ${i + 1} *`}
                      type={"number"}
                      name={`returnedAmountBsS${i}`}
                      register={register}
                      placeholder={""}
                      errors={errors[`returnedAmountBsS${i}`]?.message}
                      disabled={true}
                    />
                  </td>
                  <td>
                    <Input
                      bootstrap={"col-12"}
                      // label={`Referencia Vuelto ${i + 1} *`}
                      type={"text"}
                      name={`returnedReference${i}`}
                      register={register}
                      placeholder={""}
                      errors={errors[`returnedReference${i}`]?.message}
                    />
                  </td>
                  <td>
                    <div className="col-12">
                      <FileDropzone
                        handleDrop={handleDrop}
                        index={i}
                        file={cashBackImage[`image${i}`]}
                        removeFile={removeFile}
                        error={errorsDropzone?.[`error${i}`]}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

        </div>
      </>
    );
  } else return null;
};
